import axios from 'axios'

export default {
    getAll: () => axios.get(`/stock_catalog`),
    getById: id => axios.get(`/stock_catalog/${id}`),
    getLastActive: () => axios.get(`/stock_catalog/last_active`),
    create: formData => axios.post(`/stock_catalog/create`, formData),
    edit: formData => axios.put(`/stock_catalog/edit`, formData),
    changeStatus: formData => axios.patch(`/stock_catalog/toggle_status`, formData),
    delete: id => axios.delete(`/stock_catalog/delete/${id}`)
}